import {ChangeDetectorRef, Component, Input, OnDestroy} from "@angular/core";
import {FUIAbstractValidation} from "../abstract-validation";
import {Subscription} from "rxjs";
import {PopParentVerticalAlignment} from "../../../../../pops/abstract-pop";

@Component({
    selector: "fui-error-validation",
    styleUrls: ["error-validation.component.scss"],
    templateUrl: "./error-validation.component.html"
})
export class FUIErrorValidationComponent extends FUIAbstractValidation implements OnDestroy {
    @Input() public verticalAlignment: PopParentVerticalAlignment = PopParentVerticalAlignment.ABOVE;

    public popped: boolean;
    private _statusChanges: Subscription;

    constructor(private changeDetectorRef: ChangeDetectorRef) {
        super();
    }

    /**
     *
     * @returns {boolean}
     */
    override get focussed(): boolean {
        return super.focussed;
    }

    /**
     *
     * @param {boolean} focussed
     */
    override set focussed(focussed: boolean) {
        super.focussed = focussed;
        this.validity();
    }

    override ngOnInit(): void {
        this.validity();
        this._statusChanges = this.control.statusChanges.subscribe(() => this.validity());
    }

    ngOnDestroy(): void {
        if (this._statusChanges) {
            this._statusChanges.unsubscribe();
        }
        this.control = null;
    }

    /**
     * Check whether this validation is required
     */
    override validity(): void {
        if (this.control.dirty || this.control.touched) {
            this.popped = this.focussed;
            if (this.valid !== this.control.invalid) {
                this.valid = this.control.invalid;
                this.changeDetectorRef.markForCheck();
            }
            // Angular is failing to emit a statusChange when the control is pending
            if (this.control.pending) {
                setTimeout(() => {
                    if (this.control) {
                        this.validity();
                    }
                });
            }
        }
        else {
            this.valid = false;
        }
    }
}
